import React from 'react'
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form'
import { FormItemProps, Typography } from 'antd'
import cl from 'classnames'
import isNumber from 'lodash/isNumber'
import isString from 'lodash/isString'

import { FieldNameRegexType } from 'Core/interfaces'

import FormItem from './FormItem'

import styles from './readOnlyText.module.scss'

const { Text } = Typography

export enum fontSizeTypes {
	small = 'small',
	medium = 'medium'
}

type FormReadOnlyTextProps<FieldsType extends FieldValues> = FormItemProps & {
	wrapperClassName?: string
	control: Control<FieldsType>
	fieldName: keyof FieldsType | FieldNameRegexType
	customValue?: string
	ellipsis?: boolean
	wrapperTextClassName?: string
	fontSize?: fontSizeTypes
}

// Type guard to check if value is of type LabelValue
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isLabelValue(value: any): value is LabelValue {
	return value && typeof value.value === 'string';
}

function FormReadOnlyText<FieldsType extends FieldValues>({
	label,
	wrapperClassName,
	wrapperTextClassName,
	control,
	fieldName,
	customValue,
	ellipsis = false,
	fontSize = fontSizeTypes.small
}: FormReadOnlyTextProps<FieldsType>) {
	return (
		<Controller
			name={fieldName as FieldPath<FieldsType>}
			control={control}
			render={({ field: { value, name } }) => {
				let text = ''
				if (customValue) {
					text = customValue
				} else if (isString(value)) {
					text = value
				} else if (isNumber(value)) {
					text = (value as number).toString()
				}
				else if (isLabelValue(value)) {
					text = (value as LabelValue).label;
				}
				return (
					<FormItem
						className={cl(styles.textWrapper, wrapperClassName)}
						label={label}
						name={name}
						colon={false}
					>
						<div
							title={text}
							className={cl(
								styles.text,
								{
									[styles.smallSize]: fontSize === fontSizeTypes.small,
									[styles.mediumSize]: fontSize === fontSizeTypes.medium
								},
								wrapperTextClassName
							)}
						>
							<Text ellipsis={ellipsis}>{text}</Text>
						</div>
					</FormItem>
				)
			}}
		/>
	)
}

export default FormReadOnlyText
